module.exports = __webpack_public_path__ + "static/media/logo.df35ba29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgroundimages/logo.png
// module id = 1087
// module chunks = 0